// T119 — standard surface container. Canonical = the dashboard card
// (rounded-xl border border-slate-800 bg-slate-900/50 p-4). `tone` + `padding`
// props cover the existing bg-opacity / p-3|p-6 variants so no site is forced
// to restyle. Polymorphic `as` for <section> etc.
const TONES = { default: 'bg-slate-900/50', subtle: 'bg-slate-900/30', muted: 'bg-slate-900/40' };
const PADS = { sm: 'p-3', md: 'p-4', lg: 'p-6' };

export default function Card({ tone = 'default', padding = 'md', as: As = 'div', className = '', ...rest }) {
  return (
    <As
      className={`rounded-xl border border-slate-800 ${TONES[tone] ?? TONES.default} ${PADS[padding] ?? PADS.md} ${className}`.trim()}
      {...rest}
    />
  );
}
